import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setActiveSlideIndex } from '../../../store/auction-detail/action';
import CarImageModel from './car-images-model';

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setActiveSlideIndexConnect: setActiveSlideIndex
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarImageModel);